import { getBackendBaseUrl } from '../utils/apiUrls';

/**
 * API client for the public referral landing route (#168 slice 3). No Auth0 —
 * this is an unauthenticated public page, matching formSessionApi.js's pattern.
 */

const BACKEND_BASE = getBackendBaseUrl();

export const REFERRALS_API_URL = `${BACKEND_BASE}/referrals`;

const REFERRAL_LANDING_ERROR_MESSAGES = {
  referral_link_invalid_format: 'This referral link is invalid.',
  referral_link_not_found: 'This referral link is invalid or no longer active.',
  referral_schema_out_of_date: 'This referral link is temporarily unavailable. Please try again shortly.',
  referral_landing_lookup_failed: 'This referral link is temporarily unavailable. Please try again shortly.',
};

export function getReferralLandingErrorMessage(err, fallback = 'Unable to load this referral link.') {
  if (!err) return fallback;
  if (typeof err === 'string') return err;

  const apiMessage = err.apiMessage || err.message;
  const code = err.code || err.error;

  if (code && REFERRAL_LANDING_ERROR_MESSAGES[code]) {
    return REFERRAL_LANDING_ERROR_MESSAGES[code];
  }
  if (apiMessage && String(apiMessage).trim() && apiMessage !== code) {
    return String(apiMessage).trim();
  }
  if (code) return String(code);
  return fallback;
}

class ReferralLandingError extends Error {
  constructor({ status, code, error, apiMessage, message }) {
    super(message || apiMessage || code || error || 'Referral landing error');
    this.name = 'ReferralLandingError';
    this.status = status;
    this.code = code;
    this.error = error;
    this.apiMessage = apiMessage;
  }
}

export async function fetchReferralLanding(token) {
  const res = await fetch(`${REFERRALS_API_URL}/landing/${encodeURIComponent(token)}${window.location.search}`);
  const data = await res.json();
  if (!res.ok) {
    throw new ReferralLandingError({
      status: res.status,
      code: data?.code,
      error: data?.error,
      apiMessage: data?.message,
    });
  }
  return data;
}
